/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_External_Registration_NoticeInputs */



/**
* | output |
* | --- |
* | "Sign-ups for this event happen outside Archon. Booking a seat on the organizer's page registers you here." |
*
* @param {Tournament_External_Registration_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_external_registration_notice = /** @type {((inputs?: Tournament_External_Registration_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_External_Registration_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les inscriptions à ce tournoi se font hors d'Archon. Réserver une place sur la page de l'organisateur vous inscrit ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La inscripción a este torneo se hace fuera de Archon. Reservar plaza en la página del organizador le inscribe aquí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As inscrições deste torneio são feitas fora do Archon. Reservar uma vaga na página do organizador inscreve você aqui.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le iscrizioni a questo torneo si fanno fuori da Archon. Prenotare un posto sulla pagina dell'organizzatore ti iscrive qui.")
	return /** @type {LocalizedString} */ ("Sign-ups for this event happen outside Archon. Booking a seat on the organizer's page registers you here.")
});